import useAuthState from '@/states/auth.state';
import useTenantState from '@/states/tenant.state';
import { env } from '@/utils/constants/env';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DefaultButton } from '@/components/ui/Button';

export default function Workspaces() {
  const { tenants, loadUserProfile, token, isSuperAdmin, allTenants, loadAllTenants, logout } = useAuthState();
  const { homepageCreateNewWorkspace } = useTenantState();
  const navigate = useNavigate();
  const { setCurrentTenant } = useTenantState();

  const displayTenants = isSuperAdmin && allTenants ? allTenants : tenants;

  useEffect(() => {
    if (token && !tenants) {
      if (token) loadUserProfile(token, true);
    }
  }, [token, tenants, loadUserProfile]);

  // Load all tenants for superadmin
  useEffect(() => {
    if (token && isSuperAdmin && !allTenants) {
      loadAllTenants();
    }
  }, [token, isSuperAdmin, allTenants, loadAllTenants]);

  useEffect(() => {
    const { removeCurrentTenant } = useTenantState.getState();
    removeCurrentTenant();
  }, []);

  return (
    <section className="h-full relative">
      <div className="flex justify-between items-center px-6 py-4">
        <div
          className="flex items-center space-x-2 cursor-pointer hover:opacity-80 transition-opacity"
          onClick={() => (window.location.href = env.homePageUrl)}
        >
          <img src="/logo-aosonline.png" alt="alurkerja-logo" className="h-8" />
          <span className="text-xl font-semibold">AOS ONLINE</span>
        </div>

        <DefaultButton onClick={logout} color="primary" size="small">
          Logout
        </DefaultButton>
      </div>
      {!homepageCreateNewWorkspace ? (
        <div className="flex flex-col items-center mt-10 gap-y-2 relative z-20 bg-white">
          <h1 className="text-[40px] font-medium">Workspaces</h1>
          <p className="text-lg">Choose workspace you've joined</p>

          <div className="mt-6 w-full max-w-[786px] p-2 md:p-0">
            <div className="text-slate-500 text-sm mb-4">
              {isSuperAdmin ? 'All workspaces' : 'My workspaces'} ({displayTenants?.length})
              {isSuperAdmin && (
                <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">Super Admin</span>
              )}
            </div>
            <div className="flex flex-col gap-y-2 overflow-y-auto max-h-[calc(100vh-18rem)] md:max-h-60 rounded-xl">
              {displayTenants?.map(tenant => {
                const logoPath = tenant?.logoPath?.startsWith('htt')
                  ? tenant?.logoPath
                  : env.cloudStorage + (tenant?.logoPath || '');

                return (
                  <div
                    key={tenant.id}
                    onClick={() => {
                      setCurrentTenant(tenant);
                      navigate(`/${tenant.slug}/dashboard`);
                    }}
                    className=" gap-2 p-3 rounded-lg bg-[#F0F5FF] flex items-center cursor-pointer hover:bg-[#e0ebff] transition-colors"
                  >
                    <div className="bg-gray-200 text-primary h-7 w-7 aspect-square cursor-pointer flex items-center justify-center rounded-full overflow-hidden">
                      {tenant?.logoPath && (
                        <img src={logoPath} alt="user's avatar" className="w-full h-full aspect-square" />
                      )}
                    </div>
                    <span className="flex-1">{tenant.name}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        <CreateNewWorkspace />
      )}
    </section>
  );
}

const CreateNewWorkspace = () => {
  const [workspaceName, setWorkspaceName] = useState('');
  const { createNewWorkspace } = useTenantState();
  return (
    <>
      <div className="flex flex-col items-center mt-10 gap-y-2 relative z-20 bg-white">
        <h1 className="text-[40px] font-medium">Create New Workspace</h1>
        <p className="text-lg">Choose workspace you've joined</p>

        <div className="mt-6 w-full max-w-[786px] p-2 md:p-0">
          <div className="flex flex-col gap-y-2 overflow-y-auto max-h-[calc(100vh-18rem)] md:max-h-60 rounded-xl">
            <input
              type="text"
              placeholder="Workspace name"
              className="p-3 border border-slate-300 rounded-lg"
              value={workspaceName}
              onChange={e => setWorkspaceName(e.target.value)}
            />
            <button
              onClick={() => {
                createNewWorkspace(workspaceName);
              }}
              className="p-3 rounded-lg bg-blue-600 text-white flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors"
            >
              Create Workspace
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
